<template>
  <div :class="{'newpage':flag === true,'hideleft':hide === true}" class="page">
    <div class="page-main">
      <div class="home-tier-1 ub-box">
        <div class="tier-1-block ub-box z-width-32-precent ub-col">
          <div class="user-detail-container ub-box">
            <div class="user-avatar ub-box ub-ver">
              <div class="user-avatar-container ub-box ub-ver">
                <div class="user-img-container ub-box ub-ver">
                  <img style="margin-top: 11px;" src="../../assets/imgs/user.png" alt="">
                </div>
              </div>
            </div>
            <div style="padding-top:3.6rem;">
              <div class="z-margin-bottom-20-precent z-relative ub-box">
                <span class="z-font-size-18 z-lines-1-overflow-hidden">您好，{{username}}</span>
                <router-link v-if="!(cname == '审核成功')" to="/auth" class="user-label un-auth user-verified-origin">
                  <span v-if="!(cname == '审核成功') && ajax" class="auth-bg">
                  <i class="auth-bg-icon"></i>
                  未实名认证
                </span>
                </router-link>
                <router-link v-if="cname == '审核成功'" to="/auth" class="user-label auth_inauth"></router-link>
              </div>
              <div>会员ID：{{userid}}</div>
            </div>
          </div>
          <div>
            <div class="user-connect z-padding-h-15-precent ub-box ub-between">
              <span class="connect-icon-mobile z-font-size-14 z-color-999 z-display-block">手机号码</span>
              <span class="z-display-block"><span v-if="phone==='立即绑定>>'" class="z-color-999 z-font-size-14">尚未绑定 </span><router-link class="z-font-size-14 z-color-blue" to="/user4">{{phone}}</router-link></span>
            </div>
            <div class="user-connect z-padding-h-15-precent ub-box ub-between">
              <span class="connect-icon-email z-font-size-14 z-color-999 z-display-block">电子邮箱</span>
              <span class="z-display-block"><span v-if="email==='立即绑定>>'" class="z-color-999 z-font-size-14">尚未绑定 </span><router-link class="z-font-size-14 z-color-blue" to="/user5">{{email}}</router-link></span>
            </div>
          </div>
        </div>
        <div class="tier-1-block ub-box z-width-32-precent z-margin-left-20-precent ub-col">
          <div class="home-panel-heading-notic ub-box ub-between z-font-size-16">
            <span class="notice-title z-textAlign-center z-font-size-16 z-padding-h-20-precent">
									三丰云公告
								</span>
            <a class="font-size-12 line-height-1 z-color-blue" href="/help/?id=110" target="_blank">更多 &gt;&gt;</a>
          </div>
          <div class="notice-list-panel ub-box">
            <ul class="z-width-100-precent">
              <li v-for="(item,index) in gonggaoList" v-if="item.title && index<5" class="ub-box ub-between">
                <span class="notice-content z-oneline-overflow-hidden">
                  <span class="list-decoration-point">•</span>
                  <a :href="'/help/content_'+ item.id +'.html'" :title="item.title" target="_blank">{{item.title}}</a>
                </span>
                <span class="z-color-999">
                  {{item.setdate.split(' ')[0]}}
								</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="tier-1-block ub-box z-width-32-precent z-margin-left-20-precent ub-col">
          <ul class="ub-box home-nav z-width-100-precent">
            <li class="z-width-50-precent z-textAlign-center" v-for="(list , couponidx) in couponList" :class="{'active': couponidx === couponIndex}" @click.stop="clickCoupon(couponidx)">
              <a href="javascript:;">{{list.babel}}</a>
            </li>
          </ul>
          <div ref="couponItems" class="tab-content ub-box">
            <div class="tab-pane z-width-100-precent" v-for="(list , couponidx) in couponList" :class="{'active': couponidx === couponIndex}">
              <xul :columns="couponcolumns" :data="list['content']"/>
              <div v-if="list['length'] > 3" class="z-width-100-precent z-height-30-prcent z-textAlign-right">
                <span class="font-size-12 z-lineHeight-30 z-display-inlineBlock z-textAlign-right z-padding-right-10-precent z-color-blue z-curPonit" @click="moreCoupon">更多 &gt;&gt;</span>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!--<div class="z-margin-top-20-precent ub-box">
        <a href="/act/july/index9.html" target="_blank" class="ub-box z-width-100-precent guanggao-link">
          &lt;!&ndash;<img src="../../assets/imgs/act_december.jpg" alt="广告">&ndash;&gt;
          <div class="act-box">
            <span>【赔钱赚吆喝】</span>
            独立IP云服务器8元，点击抢购中...
          </div>
        </a>
        &lt;!&ndash;<a href="/act/vip/" target="_blank" class="ub-box z-width-100-precent guanggao-link">
          <img src="../../assets/imgs/70years.jpg" alt="广告">
        </a>&ndash;&gt;
      </div>-->
      <div class="tier-1-block ub-box z-margin-top-20-precent ub-col">
        <!-- <div class="home-panel-heading-notic ub-box z-font-size-16">
            <span class="notice-title z-textAlign-center z-font-size-18 z-padding-h-20-precent" style="color:red;font-weight: 600">
									促销专区
            </span>
        </div> -->
        
        <!-- Tab 导航 -->
        <div class="sales-tab-nav ub-box" style="border-top: 1px solid #eee;">
          <div 
            v-for="(tab, index) in salesTabs" 
            :key="index"
            class="sales-tab-item"
            :class="{'active': currentSalesTab === index}"
            @click="switchSalesTab(index)"
            style="padding: 10px 20px; cursor: pointer; border-top: 2px solid transparent; transition: all 0.3s;"
          >
            {{tab.name}}
          </div>
        </div>
        
        <!-- Tab 内容 -->
        <div class="sales-tab-content">
          <div v-for="(tab, tabIndex) in salesTabs" :key="tabIndex" v-show="currentSalesTab === tabIndex">
            <div v-for="(item,index) in tab.items" :key="index" class="pkg-card pkg-card-col">
              <div class="pkg-title">
                <span class="title">特惠{{index + 1}}型</span>
                <span>
                  <em>
                    {{item.cpu}}核{{item.ram}}G
                  </em>
                </span>
              </div>
              <div class="pkg-deploy cf">
                <div class="dropdown">
                  <div class="ui-title">线路</div>
                  <div class="ui-title" style="color:#409EFF;">
                    {{item.data_center}}
                  </div>
                </div>
                <div class="dropdown ">
                  <div class="ui-title">防御级别</div>
                  <div class="ui-title" style="color:#409EFF;">{{item.ddos_size}}G</div>
                </div>
                <div class="dropdown ">
                  <div class="ui-title">带宽</div>
                  <div class="ui-title">{{item.net_width}}M</div>
                </div>
                <div class="dropdown ">
                  <div class="ui-title">数据盘</div>
                  <div class="ui-title">{{item.ssd}}G</div>
                </div>
                <div class="dropdown ">
                  <div class="ui-title">免费获赠</div>
                  <div class="ui-title">操作系统盘</div>
                </div>
                <div class="dropdown ">
                  <div class="ui-title" >CPU性能</div>
                  <div class="ui-title" style="color:#409EFF;">{{item.cpuType}}</div>
                </div>
              </div>
              <div class="pkg-order">
                <el-radio-group v-model="item.time" size="medium">
                  <el-radio-button label="0.03">{{item.d_sanfeng_price}}元/天</el-radio-button>
                  <el-radio-button label="1">{{item.m_sanfeng_price}}元/月</el-radio-button>
                  <el-radio-button label="12">{{item.y_sanfeng_price}}元/年</el-radio-button>
                  <br>
                  <el-radio-button label="24" style="margin-top: 15px">{{item.y2_sanfeng_price}}元/两年</el-radio-button>
                  <el-radio-button label="36">{{item.y3_sanfeng_price}}元/三年</el-radio-button>
                  <el-radio-button label="48">{{item.y4_sanfeng_price}}元/四年</el-radio-button>
                </el-radio-group>
                <a class="btn-m btn-red pkg-href" @click="addCart(item)" href="javascript:;">立即开通</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="z-margin-top-20-precent" style="min-height: 100%">
        <a href="/act/vip/" target="_blank">
          <img style="width: 100%" src="../../assets/imgs/vip.png" alt="">
        </a>
      </div>-->
      <!--<div class="tier-1-block ub-box z-margin-top-20-precent ub-col">
        <div class="home-panel-heading-notic ub-box z-font-size-16">
            <span class="notice-title z-textAlign-center z-font-size-18 z-padding-h-20-precent" style="color: red;">
									特惠云服务器，首年299元
								</span>
          <a class="z-font-size-14 z-color-blue z-padding-left-20-precent" href="/act/yearsales" target="_blank" style="line-height: 49px;">更多特惠产品 &gt;&gt;</a>
        </div>
        <div class="notice-list-panel ub-box">
          <div class="server-pkg-item">
            <div class="pkg-inner">
              <div class="server-pkg-title">
                入门型(北京BGP线路)
              </div>
              <div class="server-pkg-box">
                <div class="server-pkg-config clearfix">
                  <div class="pkg-config-item">
                    <div class="pkg-config-main">
                      1<span class="pkg-config-unit">核</span>
                    </div>
                    <div class="pkg-config-sub">
                      CPU
                    </div>
                  </div>
                  <div class="pkg-config-item">
                    <div class="pkg-config-main">
                      1<span class="pkg-config-unit">G</span>
                    </div>
                    <div class="pkg-config-sub">
                      内存
                    </div>
                  </div>
                  <div class="pkg-config-item">
                    <div class="pkg-config-main">
                      5<span class="pkg-config-unit">M</span>
                    </div>
                    <div class="pkg-config-sub">
                      带宽
                    </div>
                  </div>
                </div>
                <div class="pkg-price-row">
                  <span class="pkg-price">￥299</span>元/首年
                </div>
                <div class="pkg-buy-button">
                  <a href="javascript:;" @click="addCart('11_y_bj')">立即开通</a>
                </div>
              </div>
            </div>
          </div>
          <div class="server-pkg-item">
            <div class="pkg-inner">
              <div class="server-pkg-title">
                进阶型(北京BGP线路)
              </div>
              <div class="server-pkg-box">
                <div class="server-pkg-config clearfix">
                  <div class="pkg-config-item">
                    <div class="pkg-config-main">
                      2<span class="pkg-config-unit">核</span>
                    </div>
                    <div class="pkg-config-sub">
                      CPU
                    </div>
                  </div>
                  <div class="pkg-config-item">
                    <div class="pkg-config-main">
                      2<span class="pkg-config-unit">G</span>
                    </div>
                    <div class="pkg-config-sub">
                      内存
                    </div>
                  </div>
                  <div class="pkg-config-item">
                    <div class="pkg-config-main">
                      5<span class="pkg-config-unit">M</span>
                    </div>
                    <div class="pkg-config-sub">
                      带宽
                    </div>
                  </div>
                </div>
                <div class="pkg-price-row">
                  <span class="pkg-price">￥329</span>元/首年
                </div>
                <div class="pkg-buy-button">
                  <a href="javascript:;" @click="addCart('22_y_bj')">立即开通</a>
                </div>
              </div>
            </div>
          </div>
          <div class="server-pkg-item">
            <div class="pkg-inner">
              <div class="server-pkg-title">
                通用型(北京BGP线路)
              </div>
              <div class="server-pkg-box">
                <div class="server-pkg-config clearfix">
                  <div class="pkg-config-item">
                    <div class="pkg-config-main">
                      4<span class="pkg-config-unit">核</span>
                    </div>
                    <div class="pkg-config-sub">
                      CPU
                    </div>
                  </div>
                  <div class="pkg-config-item">
                    <div class="pkg-config-main">
                      4<span class="pkg-config-unit">G</span>
                    </div>
                    <div class="pkg-config-sub">
                      内存
                    </div>
                  </div>
                  <div class="pkg-config-item">
                    <div class="pkg-config-main">
                      10<span class="pkg-config-unit">M</span>
                    </div>
                    <div class="pkg-config-sub">
                      带宽
                    </div>
                  </div>
                </div>
                <div class="pkg-price-row">
                  <span class="pkg-price">￥599</span>元/首年
                </div>
                <div class="pkg-buy-button">
                  <a href="javascript:;" @click="addCart('44_y_bj')">立即开通</a>
                </div>
              </div>
            </div>
          </div>
          <div class="server-pkg-item">
            <div class="pkg-inner">
              <div class="server-pkg-title">
                理想型(北京BGP线路)
              </div>
              <div class="server-pkg-box">
                <div class="server-pkg-config clearfix">
                  <div class="pkg-config-item">
                    <div class="pkg-config-main">
                      8<span class="pkg-config-unit">核</span>
                    </div>
                    <div class="pkg-config-sub">
                      CPU
                    </div>
                  </div>
                  <div class="pkg-config-item">
                    <div class="pkg-config-main">
                      8<span class="pkg-config-unit">G</span>
                    </div>
                    <div class="pkg-config-sub">
                      内存
                    </div>
                  </div>
                  <div class="pkg-config-item">
                    <div class="pkg-config-main">
                      10<span class="pkg-config-unit">M</span>
                    </div>
                    <div class="pkg-config-sub">
                      带宽
                    </div>
                  </div>
                </div>
                <div class="pkg-price-row">
                  <span class="pkg-price">￥999</span>元/首年
                </div>
                <div class="pkg-buy-button">
                  <a href="javascript:;" @click="addCart('88_y_bj')">立即开通</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>-->
      <!--<div class="z-margin-top-20-precent ub-box zs-bg">
        <a href="/act/vip" target="_blank" class="ub-box ub-ver z-width-100-precent">
          <img src="../../assets/imgs/zs-txt.png" height="294" alt="广告">
        </a>
      </div>-->
      <!--<div class="home-tier-auto z-margin-top-20-precent">
        <div class="home-panel-heading z-margin-h-20-precent">
          <span class="z-lineHeight-20 z-font-size-16">
            <span class="z-color-red z-font-size-16">特惠VIP产品，限量抢抢抢！！！</span>
            最低15元，下面自助开通即可！
          </span>
        </div>
        <div class="ub-box">
          <div class="ub-box z-width-32-precent z-margin-left-20-precent z-margin-bottom-15-precent z-padding-left-15-precent ub-col bg-purple">
            <div class="ub-row z-margin-v-10-precent z-lineHeight-25">
              <p class="z-font-size-14">
                特惠云服务器  首月
                <span class="z-color-red z-font-size-20 z-font-weight-700">15元</span>
                ，首年
                <span class="z-color-red z-font-size-20 z-font-weight-700">500元</span>
              </p>
              <p class="z-color-000">内存：2G &nbsp;&nbsp;|&nbsp;&nbsp; CPU：2核 &nbsp;&nbsp;|&nbsp;&nbsp; 带宽:5M &nbsp;&nbsp;|&nbsp;&nbsp; SSD数据盘:10G</p>
              <p class="z-color-000">送系统盘，送独立IP，北京BGP多线机房</p>
            </div>
            <div class="z-margin-bottom-20-precent">
              <el-button type="primary" style="background-color: #05baf1;border-color: #05baf1;" @click="addCart('22')">首月15元 立即开通</el-button>
              <el-button type="primary" style="background-color: #05baf1;border-color: #05baf1;" @click="addCart('222')">首年500元 立即开通</el-button>
            </div>
          </div>
          <div class="ub-box z-width-32-precent z-margin-left-20-precent z-margin-bottom-15-precent z-padding-left-15-precent ub-col bg-purple">
            <div class="ub-row z-margin-v-10-precent z-lineHeight-25">
              <p class="z-font-size-14">
                特惠云服务器  首月
                <span class="z-color-red z-font-size-20 z-font-weight-700">30元</span>
              </p>
              <p class="z-color-000">内存：4G &nbsp;&nbsp;|&nbsp;&nbsp; CPU：4核 &nbsp;&nbsp;|&nbsp;&nbsp; 带宽:5M &nbsp;&nbsp;|&nbsp;&nbsp; SSD数据盘:10G</p>
              <p class="z-color-000">送系统盘，送独立IP，北京BGP多线机房</p>
            </div>
            <div class="z-margin-bottom-20-precent">
              <el-button type="primary" style="background-color: #05baf1;border-color: #05baf1;" @click="addCart('44')">首月30元 立即开通</el-button>
            </div>
          </div>
          <div class="ub-box z-width-32-precent z-margin-left-20-precent z-margin-bottom-15-precent z-padding-left-15-precent ub-col bg-purple">
            <div class="ub-row z-margin-v-10-precent z-lineHeight-25">
              <p class="z-font-size-14">
                特惠云服务器  首月
                <span class="z-color-red z-font-size-20 z-font-weight-700">60元</span>
              </p>
              <p class="z-color-000">内存：8G &nbsp;&nbsp;|&nbsp;&nbsp; CPU：8核 &nbsp;&nbsp;|&nbsp;&nbsp; 带宽:10M &nbsp;&nbsp;|&nbsp;&nbsp; SSD数据盘:10G</p>
              <p class="z-color-000">送系统盘，送独立IP，北京BGP多线机房</p>
            </div>
            <div class="z-margin-bottom-20-precent">
              <el-button type="primary" style="background-color: #05baf1;border-color: #05baf1;" @click="addCart('88')">首月60元 立即开通</el-button>
            </div>
          </div>
        </div>
      </div>-->
      <div class="home-tier-2 z-margin-top-20-precent ub-box">
        <div class="operate-container ub-box z-width-100-precent">
          <div class="operate-container-left ub-box">
            <div class="operate-links ub-box">
              <span class="z-color-999 z-margin-right-5-precent">可用余额：</span>
              <span class="detail-count-container z-font-size-16">
									<span class="user-balance z-font-size-22">{{money}}</span><span>.{{smoney}}</span> 元
								</span>
              <el-button type="primary" style="background-color: #FF8800;border-color: #FF8800;padding: 9px 22px;" @click="$router.push('/caiwu')">立即充值</el-button>
              <el-button type="primary" style="background-color: #04BAF0;border-color: #04BAF0;color: #F2F2F2;padding: 9px 22px;" @click="$router.push('/caiwu2')">收支明细</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="home-tier-3 z-margin-top-20-precent">
        <div class="home-panel-heading">
          <span class="z-lineHeight-20 z-font-size-16">已开通产品</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <router-link to="/product">
              <div class="grid-content bg-purple ub-box">
                <div class="product-left ub-box ub-ver ub-ver-v">
                  <div class="product-num" :class="{'notzero': product.freehost_count != 0}">
                    {{product.freehost_count}}
                  </div>
                </div>
                <div class="product-right">
                  <h4 class="z-font-size-15 z-lineHeight-30">免费虚拟主机</h4>
                  <p>开通即用、永久免费、送免备案服务</p>
                </div>
              </div>
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link to="/freeServerList">
              <div class="grid-content bg-purple ub-box">
                <div class="product-left ub-box ub-ver ub-ver-v">
                  <div class="product-num" :class="{'notzero': product.freevps_count != 0}">
                    {{product.freevps_count}}
                  </div>
                </div>
                <div class="product-right">
                  <h4 class="z-font-size-15 z-lineHeight-30">免费云服务器</h4>
                  <p>永久免费、功能强大、送免备案服务</p>
                </div>
              </div>
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link to="/freeBeian">
              <div class="grid-content bg-purple ub-box">
                <div class="product-left ub-box ub-ver ub-ver-v">
                  <div class="product-num" :class="{'notzero': product.mba_domain != 0}">
                    {{product.mba_domain}}
                  </div>
                </div>
                <div class="product-right">
                  <h4 class="z-font-size-15 z-lineHeight-30">免备案服务</h4>
                  <p>提交域名无需备案即可访问</p>
                </div>
              </div>
            </router-link>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <router-link to="/vhostList">
              <div class="grid-content bg-purple ub-box">
                <div class="product-left ub-box ub-ver ub-ver-v">
                  <div class="product-num" :class="{'notzero': product.vhost_count != 0}">
                    {{product.vhost_count}}
                  </div>
                </div>
                <div class="product-right">
                  <h4 class="z-font-size-15 z-lineHeight-30">虚拟主机</h4>
                  <p>共享和独享IP虚拟主机随意选</p>
                </div>
              </div>
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link to="/serverList">
              <div class="grid-content bg-purple ub-box">
                <div class="product-left ub-box ub-ver ub-ver-v">
                  <div class="product-num" :class="{'notzero': product.vps_count != 0}">
                    {{product.vps_count}}
                  </div>
                </div>
                <div class="product-right">
                  <h4 class="z-font-size-15 z-lineHeight-30">云服务器</h4>
                  <p>不同配置满足您不同的应用</p>
                </div>
              </div>
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link to="/domainList">
              <div class="grid-content bg-purple ub-box">
                <div class="product-left ub-box ub-ver ub-ver-v">
                  <div class="product-num" :class="{'notzero': product.domain_count != 0}">
                    {{product.domain_count}}
                  </div>
                </div>
                <div class="product-right">
                  <h4 class="z-font-size-15 z-lineHeight-30">域名</h4>
                  <p>各种后缀域名，开启网络第一步</p>
                </div>
              </div>
            </router-link>
          </el-col>
        </el-row>
      </div>
      <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
      <el-dialog title="重要通知" :lock-scroll="true" :visible="dialognotice" width="660px" :show-close="false">
        尊敬的三丰云用户，即日起海外线路进行调整，预计在9月15日之前恢复，在此期间海外线路将无法访问。国内线路访问不受影响。
        <br>

        另：针对近期的网络攻击恶性事件，三丰云已经全面加入中国电信的云堤防御体系，目前线路正在调测中,如有个别访问异常，请您耐心等待调测完毕后即可正常。
        <br>

        2018年9月12日
        <br>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialognotice = false">关闭通知</el-button>
        </div>
      </el-dialog>
      <!--blackpink-->
      <div v-if="dialogShadow" class="dialogShadow"></div>
      <dl v-if="dialogShadow" class="dialogBody ub-box ub-col">
      <dd class="dialogTitle z-font-size-16">
        <span class="z-font-size-18 z-padding-left-10-precent">提示信息</span>
        <a class="aui_close" href="javascript:;" @click="clickBtn()">×</a>
      </dd>
      <dd class="dialogContent z-color-666 z-font-size-15 ">
        <img style="margin-left: 30px;margin-right: 30px;vertical-align: middle" src="../../assets/imgs/uc_warn.png" alt="">
        <span class="z-font-size-15" v-if="info ==='smrz_fail'">您的帐户还没有实名认证</span>
        <span class="z-font-size-15" v-if="info !='smrz_fail'">{{info}}</span>
        <br>
        <router-link v-if="info ==='smrz_fail'" to="/auth" class="z-color-a z-font-size-15" style="display: inline-block;margin-left: 127px">点击这里实名认证</router-link>
        <router-link v-if="info !='smrz_fail'" to="/caiwu" class="z-color-a z-font-size-15" style="display: inline-block;margin-left: 200px">点击充值</router-link>
      </dd>
      <div class="dialogFooter ub-f1 ub-box ub-ver z-padding-v-15-precent">
        <!--<dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(true)" style="background:#2ebace;">确认</dd>
        <dd class="confirmBtn z-relative z-color-fff z-curPonit" @click="clickBtn(false)" style="">取消</dd>-->
      </div>
    </dl>
    </div>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import Xbutton from 'commons/Xbutton.vue'
  import XhomeTable from 'components/commons/XhomeTable.vue'
  import Xul from 'components/commons/Xul.vue'
  import userService from 'business/userService.js'
  import helpService from 'business/helpService.js'
  import VpsService from 'business/VpsService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        dialognotice:false,
        dialogLoading:false,
        dialogShadow:false,
        ajax:false,
        cname:'',
        username: '',
        userid: '',
        phone: '',
        email: '',
        money: '0',
        smoney: '00',
        couponIndex: 0,
        couponList: [],
        gonggaoList: [

        ],
        userList: [],
        product:{},
        columns: [
          {
            label: '我的业务',
            key: 'name',
            col: 'icon',
          },
          {
            label: '拥有数量',
            key: 'num',
            category: 'Xspan',
            col: 'all',
          },
          {
            label: '即将到期',
            key: 'soonnum',
            category: 'Xspan',
            col: 'over',
          },
          {
            label: '已经到期',
            key: 'latenum',
            category: 'Xspan',
            col: 'pre',
          }
        ],
        couponcolumns: [
          {
            label: '编号',
            key: 'name',
          },
          {
            label: '面值',
            key: 'money',
            col: 'mian'
          },
          {
            label: '过期时间',
            key: 'istime',
          }
        ],
        currentPage: 0,
        counts: 12,
        info:'',
        Sales: [
          
        ],
        currentSalesTab: 0,
        salesTabs: []
      }
    },
    components: {
      XdialogLoading,
      XhomeTable,
      Xbutton,
      Xul
    },
    props:{
      flag:Boolean,
      hide:Boolean
    },
    mounted(){
      this.getAllUser('userInfo','cmd=userinfo')
      // this.Sales.map((item,index)=>{
      //   return{
      //     cpu: item.cpu,
      //     ram: item.ram,
      //     net: item.net,
      //     price_y: this.getPrice(item,12,item.id),
      //     price_m: this.getPrice(item,1,item.id),
      //     price_3: this.getPrice(item,36,item.id),
      //     net_type:item.net_type,
      //     time:item.time,
      //   }
      // });
      this.getSales()
      this.getGonggao()
    },
    methods: {
      ...mapActions(['SETFIRST_MENU','SETSECOND_MENU','SETTHREE_MENU']),
      async getSales () {
        let data = 'cmd=vps_price'
        let {vueData, state} = await VpsService.transformToVue('vpsInfo','POST',data)
        if(vueData.response==200){
          this.Sales = vueData.msg.map((item)=>{
            return {...item,time:12}
          })
          
          // 按 data_center 分组
          this.groupSalesByDataCenter()
        }else {
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async getAllUser(urlType,data) {
        let {vueData, state} = await userService.transformToVue(urlType,'POST',data)
        if(state.code === '000' ) {
          this.product = vueData.msg.product
          let msg = vueData.msg
          let onuse = msg.yhq.onuse.map((item, index) => {
            return {
              name: item.yhq_id,
              mian: [
                {
                  font: '￥'+item.money_all.split('.')[0],
                  type: 'white',
                  optionStyle:{padding: '.4rem .8rem .4rem .65rem',background: '#00c0ff',width: '2.5rem',height: '1rem', margin: '.6rem 0 0 .2rem',lineHeight: '1rem'},
                }
              ],
              istime: item.end_time.split(' ')[0],
            }
          })
          let onuselength = msg.yhq.onuse.length
          let timeout = msg.yhq.timeout.map((item, index) => {
            return {
              name: item.yhq_id,
              mian: [
                {
                  font: '￥'+item.money_all.split('.')[0],
                  type: 'white',
                  optionStyle:{padding: '.4rem .8rem .4rem .65rem',background: '#00c0ff',width: '2.5rem',height: '1rem', margin: '.6rem 0 0 .2rem',lineHeight: '1rem'},
                }
              ],
              istime: item.end_time.split(' ')[0],
            }
          })
          let timeoutlength = msg.yhq.timeout.length
          let used = msg.yhq.used.map((item, index) => {
            return {
              name: item.yhq_id,
              mian: [
                {
                  font: '￥'+item.money_all.split('.')[0],
                  type: 'white',
                  optionStyle:{padding: '.4rem .8rem .4rem .65rem',background: '#00c0ff',width: '2.5rem',height: '1rem', margin: '.6rem 0 0 .2rem',lineHeight: '1rem',},
                }
              ],
              istime: item.end_time.split(' ')[0],
            }
          })
          let usedlength = msg.yhq.used.length
          let onusecon = onuse.slice(0,3)
          let timeoutcon = timeout.slice(0,3)
          let usedcon = used.slice(0,3)
          this.cname = msg.cert_state
          this.username = msg.cert_name || msg.ID_Mobile
          this.userid = msg.userid
          this.phone = msg.ID_Mobile ? msg.ID_Mobile : '立即绑定>>'
          this.email = msg.ID_Email ? msg.ID_Email : '立即绑定>>'
          let money = msg.money || "0";
          if (String(money).indexOf(".") == -1) {
            money += ".00";
          }
          this.money = money.split('.')[0]
          this.smoney = money.split('.')[1]

          this.couponList = [
            {
              babel: '可用优惠券',
              content: onusecon,
              length: onuselength
            },
            {
              babel: '已用优惠券',
              content: usedcon,
              length: usedlength
            }
          ]
          this.userList = [{
            name:'域名',
            num: vueData.msg.product.domain_count_all,
            pre: vueData.msg.product.domain_count_pre,
            over: vueData.msg.product.domain_count_over
          }, {
            name:'虚拟主机',
            num: vueData.msg.product.vhost_count_all,
            pre: vueData.msg.product.vhost_count_pre,
            over: vueData.msg.product.vhost_count_over
          }, {
            name:'云服务器',
            num: vueData.msg.product.vps_count_all,
            pre: vueData.msg.product.vps_count_pre,
            over: vueData.msg.product.vps_count_over
          }]
          this.ajax = true
        }else {
          this.$toast({tip:'请刷新页面...',type:'3'})
        }
      },
      async getGonggao() {
        let arr = [7,8,9]
        let {vueData, state} = await helpService.transformToVue('helpInfo','POST','cmd=query&type_id=257&id='+arr)
        if(vueData.response==200){
          this.gonggaoList = vueData.msg.content
        }else {
          this.$toast({tip:'请刷新页面...',type:'3'})
        }
      },
      clickCoupon(idx) {
        this.couponIndex = idx
        Array.from(this.$refs.couponItems).forEach((item, inx)=>{
          if( inx === idx ) {
            item.style.display = 'block'
          }else {
            item.style.display = 'none'
          }
        })
      },
      moreCoupon() {
        sessionStorage.setItem('secondMenu',2)
        sessionStorage.setItem('threeMenu',0)
        this.$router.push('/voucher')
      },
      async getPrice(item,time,id) {
        let data = 'cmd=vps_try_price' +
          '&vps_type=' + id +
          '&net_type=BJBGP' +
          '&time=' + time;
        let {vueData, state} = await VpsService.transformToVue('vpsBuyInfo','POST',data)
        if(true){
          this.Sales.map((x, index) => {
            if(id == x.id){
              if(time == 12){
                x.price_y = vueData.price
              }else if(time == 36){
                x.price_3 = vueData.price
              }else{
                x.price_m = vueData.price
              }
              x.cpu = vueData.cpu;
              x.net = vueData.net;
              x.ram = vueData.ram;
              x.ssd = vueData.ssd;
            }
          })
        }else {
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async addCart(item) {
        MessageBox.confirm('将从您账户中扣除相应费用', '是否开通？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          let data = 'cmd=vps_try_bj'+
            '&vps_type=' + item.vps_type +
            '&net_type=' + item.net_type +
            '&time=' + item.time;
          this.dialogLoading = true
          let {vueData, state} = await VpsService.transformToVue('vpsBuyInfo','POST',data)
          if(vueData.response==200){
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {self.$router.push('/serverList')}})
          }else {
            this.dialogLoading = false
            if(vueData.msg === 'smrz_fail'){
              this.info = vueData.msg
              this.dialogShadow = true
            }else if(vueData.response == 500999){
              this.info = vueData.msg
              this.dialogShadow = true
            }else {
              this.$dialog({type:'error', info: vueData.msg, click () {}})
            }
          }
        }).catch(() => {

        });
      },
      clickBtn() {
        this.dialogShadow = false
      },
      // 按 data_center 分组销售数据
      groupSalesByDataCenter() {
        const groups = {}
        
        this.Sales.forEach(item => {
          const dataCenter = item.data_center || '其他'
          if (!groups[dataCenter]) {
            groups[dataCenter] = []
          }
          groups[dataCenter].push(item)
        })
        
        // 转换为 tab 格式
        this.salesTabs = Object.keys(groups).map((key, index) => ({
          name: key,
          items: groups[key]
        }))
        
        // 设置默认选中第一个 tab
        if (this.salesTabs.length > 0) {
          this.currentSalesTab = 0
        }
      },

      // 切换销售 tab
      switchSalesTab(index) {
        this.currentSalesTab = index
      }
    }
  }
</script>
<style scoped>
  .newpage { margin-left: 80px; }
  .hideleft { margin-left: 80px; }
  .page-main { background-color: #f6f5fa; border: 0;}
  .home-tier-1 { height: 260px; }
  .tier-1-block { background-color: #fff; border: 1px solid #eaedf1;}
  .home-tier-2 { height: 92px; background-color: #fff; border: 1px solid #eaedf1;}
  .home-tier-3 { height: 240px; padding: 0 2rem 2.6rem 2rem; background-color: #fff; border: 1px solid #eaedf1;}
  .home-tier-auto { height: auto; background-color: #fff; border: 1px solid #eaedf1;}
  .user-detail-container { height: 156px;background-color: #3fa0dc;color: #fff;width: 100%; }
  .user-avatar {width: 130px;vertical-align: middle;}
  .user-avatar-container { width: 100px; height:100px; background: #74d0e9; border-radius: 50px;}
  .user-img-container { width: 80px; height:80px; background: #ffff; border-radius: 40px;}
  .user-label {
    display: inline-block;
    width: 16px;
    min-width: 16px;
    height: 16px;
    background: no-repeat center;
    margin: 4px 22px 0 4px;
  }
  .un-auth { vertical-align: -8%; }
  .user-verified-origin {
    background-image: url(../../assets/imgs/home_icon_vip_gray.png);
  }
  .auth_inauth {
    background-image: url(../../assets/imgs/auth_inauth.png);
  }
  .user-connect { height: 4.2rem; line-height: 4.1rem; }
  .connect-icon-mobile { padding-left: 2.5rem; background: url(../../assets/imgs/home_icon_mobile.gif) no-repeat 2px center;}
  .connect-icon-email { padding-left: 2.5rem; background: url(../../assets/imgs/home_icon_email.gif) no-repeat 2px center;}
  .user-connect:first-child {border-bottom: 1px solid #eee;}
  .secretary-detail img {position: absolute;bottom: 10px;left: 58%;width: 100px;height: 100px;margin-left: -61px;}
  .operate-container { padding: 2.6rem 2rem; }
  .operate-links { line-height: 2.8rem; }
  .detail-count-container {margin-right: 2.0rem;color: #ff8800;}
  .home-panel-heading {
    padding: 1.8rem 0;
  }
  .home-panel-heading-notic {
    border-bottom: 1px solid #eee;
    padding-right: 20px;
    background-color: #fafafa;
    line-height: 3.9rem;
    color: #606f80;
  }
  .notice-title {
    display: inline-block;
    border-top: 3px solid #009FD9;
    border-right: 1px solid #eee;
    color: #009FD9;
    background: #fff;
  }
  .notice-list-panel {
    padding: 5px 18px;
  }
  .notice-list-panel li:first-child {
    border-top: none;
  }
  .notice-list-panel li {
    line-height: 3.3rem;
    border-top: 1px dashed #eee;
  }
  .list-decoration-point {
    color: #009FD9;
  }
  .notice-content {
    display: inline-block;
    max-width: 70%;
  }
  .home-nav >li >a {
    color: #fff;
    cursor: pointer;
    background-color: #75808e;
    border: none;
    border-bottom-color: transparent;
    display: block;
    padding: .8rem 1.5rem;
  }
  .home-nav >li.active >a {
    color: #555;
    cursor: default;
    background-color: #fff;
    border: none;
    border-bottom-color: transparent;
  }
  .tab-content {
    height: 16rem;
    padding: 0 1rem;
  }
  .tab-content .tab-pane {
    display: none;
  }
  .tab-content .tab-pane.active{
    display: block;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .bg-purple {
    background: #f6f7fb;
  }
  .grid-content {
    min-height: 80px;
    border: 1px solid #fff;
  }
  .grid-content:hover {
    border: 1px solid #02b9ef;
  }
  .grid-content:hover .product-num{
    background-color: #02b9ef;
  }
  .grid-content:hover .product-right h4{
    color: #02b9ef;
  }
  .product-left {
    width: 80px;
    height: 80px;
    background-color: #eceff9;
  }
  .product-right {
    padding: 1.2rem;
  }
  .product-right h4 {
    color: #000;
  }
  .product-num {
    width: 40px;
    height: 40px;
    background-color: #ccd5f0;
    border-radius: 20px;
    line-height: 40px;
    text-align: center;
    font-size: 21px;
    color: #fff;
  }
  .product-num.notzero {
    background-color: #5c74bd;
  }
  .auth-bg {
    display: inline-block;
    position: absolute;
    top: -25px;
    right: -4px;
    background-color: #000;
    color: #fff;
    width: 72px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    border-radius: 2px;
  }
  .auth-bg-icon {
    display: inline-block;
    position: absolute;
    bottom: -7px;
    left: 32px;
    width: 11px;
    height: 7px;
    background: url(../../assets/imgs/sanjiao.png) no-repeat;
  }
  .guanggao-link {
    background-color: #FF6600;
    /*background-color: #C52B2B;*/
  }
  .zs-bg {
    width: 100%;
    height: 377px;
    background: url(../../assets/imgs/zhongshen.jpg) no-repeat;
  }
  .dialogShadow{position:fixed;z-index:9900;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);}
  .dialogBody{position:fixed;z-index:9909;top:37%;left:50%;transform:translateX(-50%);min-width:32rem;background:#fff;box-shadow: 0 0 10px 3px rgba(0,0,0,.2);animation:dialogAnimStart .2s forwards}
  .dialogTitle{position:relative;padding:1rem 0;background:#f7f9fa;color:#636566;}
  .dialogContent{padding: 2rem 2rem 2rem 0}
  .dialogFooter{background:#f7f9fa;}
  @keyframes dialogAnimEnd{
    from{opacity:1}
    to{opacity:0}
  }
  .aui_close {
    position: absolute;
    padding: 0;
    top: 31%;
    right: 22px;
    width: 21px;
    height: 21px;
    line-height: 21px;
    font-size: 30px;
    color: #636566;
    text-align: center;
    font-family: Helvetica, STHeiti;
  }
  .act-box {
    background-color: #ff6600;
    font-size: 30px;
    color: #fff;
    line-height: 120px;
  }
  .act-box span {
    font-size: 48px;
    color: yellow;
  }
  .sales-tab-nav {
    background-color: #fafafa;
  }

  .sales-tab-item {
    color: #606f80;
    font-size: 14px;
  }

  .sales-tab-item:hover {
    color: #409EFF;
  }

  .sales-tab-item.active {
    color: #409EFF;
    border-top-color: #409EFF !important;
    font-weight: 600;
  }

  .sales-tab-content {
    min-height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/index.vue